export const agent = {
  "SeekingRepresentation.Filters.genderFilter": "GENDER_FILTER_TEST_ID",
  "AgencySettings.JobFeedSettings.treatJobsAsReadToggle":
    "TREAT_JOBS_AS_READ_TOGGLE_TEST_ID",
  "AgencySettings.JobFeedSettings.saveChanges": "SAVE_CHANGES_TEST_ID",
  "AgencySettings.JobFeedSettings.confirm": "CONFIRM_TEST_ID",
};
